import React, { useMemo, useState } from "react";
import { Button, InputNumber } from "antd";
import { MinusOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";

const InputMobileNumber = ({
  inputRef,
  prefix = <UserOutlined />,
  value,
  defaultValue,
  onChange,
  min = 0,
  max,
  step = 1,
  size = "large",
  placeholder = "0",
  disabled = false,
}) => {
  const isControlled = value !== undefined;
  const [innerValue, setInnerValue] = useState(defaultValue);

  const currentValue = useMemo(() => {
    if (isControlled) return value;
    return innerValue;
  }, [innerValue, isControlled, value]);

  const setValue = (nextValue) => {
    if (isControlled === false) {
      setInnerValue(nextValue);
    }

    if (typeof onChange === "function") {
      onChange(nextValue);
    }
  };

  const clampValue = (nextValue) => {
    if (nextValue === null || nextValue === undefined) return nextValue;

    let clampedValue = nextValue;

    if (min !== undefined && clampedValue < min) clampedValue = min;
    if (max !== undefined && clampedValue > max) clampedValue = max;

    return clampedValue;
  };

  const adjustValue = (direction) => {
    const numericValue = typeof currentValue === "number" ? currentValue : (min ?? 0);
    const delta = direction === "up" ? step : -step;
    const nextValue = clampValue(numericValue + delta);
    setValue(nextValue);
  };

  return (
    <div style={{ display: "flex", width: "100%", gap: 8, alignItems: "center" }}>
      <div style={{ flex: "1 1 0", minWidth: 0 }}>
        <InputNumber
          ref={inputRef}
          value={currentValue}
          onChange={(nextValue) => setValue(clampValue(nextValue))}
          controls={false}
          min={min}
          max={max}
          step={step}
          size={size}
          disabled={disabled}
          prefix={prefix}
          style={{ width: "100%" }}
          placeholder={placeholder}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "row", gap: 8, flex: "0 0 auto" }}>
        <Button
          aria-label="Diminuir"
          type="primary"
          size={size}
          disabled={disabled}
          icon={<MinusOutlined />}
          onClick={() => adjustValue("down")}
          style={{ width: 52, height: 44, flex: "0 0 auto" }}
        />
        <Button
          aria-label="Aumentar"
          type="primary"
          size={size}
          disabled={disabled}
          icon={<PlusOutlined />}
          onClick={() => adjustValue("up")}
          style={{ width: 52, height: 44, flex: "0 0 auto" }}
        />
      </div>
    </div>
  );
};

export default InputMobileNumber;
